import { ClientRiskDataAPI } from "../API/client_risk_data";
import { getDayMonthYearByPtDate } from "../components/utils/utils";

//As informações da tela de Risco são geradas no servidor (src/controllers/utils/risk_utils.js) e
//guardadas em client_risk_data. Assim a OUTER_API também consegue devolver competências que
//nunca foram abertas na tela
export const RiskController = {

    //{ market, articles, benchmarks, policy, resolution, errors }, ou null se a requisição falhar.
    //errors lista as abas que não puderam ser geradas (elas voltam nulas)
    async getRiskData(clientId, referenceDate) {

        const { month, year } = getDayMonthYearByPtDate(referenceDate);

        const response = await ClientRiskDataAPI.buildData(clientId, month, year);

        return response.success ? response.body : null;
    },

    async getMarketData(clientId, referenceDate) {

        const riskData = await this.getRiskData(clientId, referenceDate);

        return riskData ? riskData.market : null;
    },

}